if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

var theme = theme || {};
theme.MealPlan = (function() {

  function MealPlan(container, activeWeek, mealplan, calories, min_meals, mealPlanTitle) {
    this.container = container;
    this.$container = $(container); // For jQuery
    this.productInfo = JSON.parse(document.getElementById('productInfo').innerHTML);
    this.mealPlan = mealplan;
    this.calories = calories || null;
    this.$mealList = $('.meal__list');
    this.min_meals = min_meals || 5;
    this.meal_count = 0;
    this.max_meals = 15;
    this.mealPlanTitle = mealPlanTitle.split(' - ')[0];
    this.addMealPlanBtn = document.querySelector('.btn--add-to-cart');
    this.addIcon = document.getElementById('addIcon').innerHTML;
    this.mealCost = document.querySelector('.mealplan__footer-summary .mealplan__cost > .price');
    this.activeWeek = activeWeek;
    this.activeWeekContainer = document.querySelector('.mealplan__week[data-week="' + this.activeWeek + '"]');
    this.meals = {}
    this.meals[this.activeWeek] = {
      breakfast: [],
      lunch: [],
      dinner: [],
      snacks: []
    }
    var productCards = this.container.querySelectorAll('.product-card');

    var self = this;

    if (productCards.length) {
      productCards.forEach(function(product) {
        var addItemBtn = product.querySelector('.product-card__add');
        var addedItemBtn = product.querySelector('.product-card__added');
        var removeItemBtn = product.querySelector('.product-card__remove');
        if (!addItemBtn && !removeItemBtn) return;
        addItemBtn.addEventListener('click', self.addMeal.bind(self));
        removeItemBtn.addEventListener('click', self.removeMeal.bind(self));
      });
    }

    document.querySelectorAll('.btn--week').forEach(function(weekBtn) {
      weekBtn.addEventListener('click', self.switchWeek.bind(self));
    });
    if (this.addMealPlanBtn) {
      this.addMealPlanBtn.addEventListener('click', this.addMealPlan.bind(this));
    }

    this.$mealList.each(function(index, elem) {
      // Find the arrows for each slide show so that we're extra specific and not attaching to the arrows of another slideshow
      var nextArrow = $(elem).parent().find('.arrow.arrow--next');
      var prevArrow = $(elem).parent().find('.arrow.arrow--prev');
      var $dots = $(elem).parent().find('.meal__list--count');

      // Slick initialise event
      $(elem).on('init', function(evt, slick) {
        var $this = $(this);
        $(elem).css({'visibility': 'visible'});
        slideCount = $(elem).find('.product-card').length;
        var slidesShowing = slick.currentSlide + slick.options.slidesToShow;
        if (slick.slideCount < slick.options.slidesToShow) {
          slidesShowing = slick.slideCount;
        }
        // var slidesToShow = $(elem).slick('slickGetOption', 'slidesToShow');
        $dots.html((slidesShowing) + '/' + slick.slideCount);
      });

      // Initialise Slick
      $(elem).slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        nextArrow: nextArrow,
        prevArrow:  prevArrow,
        infinite: false,
        responsive:[
          {
            breakpoint: 1150,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '40px',
              infinite: true
            }
          }
        ]
      });

      // Update slide counter on change
      $(elem).on('afterChange', function(evt, slick, currentSlide) {
        var previousDifference = parseInt($dots.html().split('/')[0], 10);
        var difference = currentSlide + slick.options.slidesToShow;
        if (difference > slick.slideCount) {
          difference = slick.slideCount;
        }
        $dots.html(difference +' / '+ slick.slideCount);
      });
    });

    $('.mealplan__footer-meals').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      mobileFirst: true,
      centerMode: true,
      infinite: true,
      centerPadding: '20px',
      responsive: [
        {
          breakpoint: 480,
          settings: "unslick"
        }
      ]
    });

    this.renderPage();
  }


  MealPlan.prototype.addMeal = function(event) {
    // Add the meal plan to the list based off of the type.
    event.preventDefault();
    var addBtn = event.target;
    var productCard = addBtn.closest('.product-card');
    var productId = parseInt(productCard.dataset.productId, 10);
    var mealType = addBtn.closest('.meal').dataset.mealType;
    // Find the product information.
    var product = this.productInfo[mealType].find(function(product) {
      return product.id === productId;
    });

    var meals = this.meals[this.activeWeek][mealType];

    // Add the meal to the mealType and increase the meal count.
    meals.push(product);
    this.meals[this.activeWeek][mealType] = meals;
    this.meal_count++;
    productCard.classList.add('product-card--added');
    productCard.querySelector('.product-details--added').style.display = "block";
    // Do all the necessary re-rendering;
    this.renderPage();
    if (meals.length === (this.max_meals/3)) {
      this.disableMealType(mealType);
    }
  }

  MealPlan.prototype.removeMeal = function(event) {
    event.preventDefault();
    var btn = event.target;
    var productCard = btn.closest('.product-card');
    var productId = parseInt(productCard.dataset.productId, 10);
    var mealType = btn.closest('.meal').dataset.mealType;
    var newMealPlan = [];
    var found = false
    var meals = this.meals[this.activeWeek][mealType];
    // Reduce the meal count.
    this.meal_count--;
    this.meals[this.activeWeek][mealType] = meals.forEach(function(meal) {
      if (meal.id === productId) {
        found = true;
        return;
      }
      newMealPlan.push(meal);
    });
    this.meals[this.activeWeek][mealType] = newMealPlan;
    // If that was the only meal of that kind in the menu then remove the product added class.
    var multipleMeals = this.meals[this.activeWeek][mealType].findIndex(function(meal) { return meal.id === productId });
    if (multipleMeals === -1) {
      productCard.classList.remove('product-card--added');
      productCard.querySelector('.product-details--added').style.display = "none";
    }


    this.renderPage();
    this.enableMealType(mealType);
  }

  MealPlan.prototype.renderPage = function() {
    var mealTypes = Object.keys(this.meals[this.activeWeek]);
    var footer = document.querySelector('.mealplan__footer');
    var self = this;
    var meals = this.meals[this.activeWeek];
    mealTypes.forEach(function(mealType) {
      var summary = footer.querySelector('[data-meal-summary="' + mealType + '"]');
      if (!summary) {
        return;
      }
      var summaryMeals = summary.querySelectorAll('.selected-meal');
      var products = meals[mealType];
      var span = summary.querySelector('span');

      span.innerHTML = products.length + ' x ' + mealType[0].toUpperCase() + mealType.slice(1);
      if (products.length === 0) {
        span.innerHTML = "Add " + mealType[0].toUpperCase() + mealType.slice(1);
      }
      if (products.length < summaryMeals.length) {
        summaryMeals[summaryMeals.length - 1].innerHTML = self.addIcon;
      }
      summaryMeals.forEach(function(summaryMeal, summaryMealIndex) {
        var product = products[summaryMealIndex];
        if (!product) {
          summaryMeal.style.backgroundImage = '';
          return;
        }

        // Update the background image of the summary to be an image of the meal.
        summaryMeal.style.backgroundImage = 'url(' + product.images[0] + ')';
        summaryMeal.style.backgroundSize = 'cover';
        if (productIndex = summaryMeals.length) {
          summaryMeal.innerHTML = '';
        }
      });
    });
    // Check if we need to enable the button or not.
    if (this.meal_count >= this.min_meals) {
      this.addMealPlanBtn.disabled = false;
    } else if (this.meal_count === this.max_meals) {
      this.disableAllMealPlans();
    } else {
      this.addMealPlanBtn.disabled = true;
    }

    // Update the mealcost.
    this.mealCost.innerHTML = "$" + (this.meal_count * 10)
  }

  // If we've reached the maximum number of meals for this type then we need to disable the meal types.
  MealPlan.prototype.disableMealType = function(mealType) {
    var mealList = this.activeWeekContainer.querySelector('.meal[data-meal-type="' + mealType + '"]');
    mealList.querySelectorAll('.product-card').forEach(function(productCard) {
      productCard.classList.add('product-card--disabled');
      productCard.querySelector('.product-details--added').style.display = "block";
    });
  }

  // If someone removed a mealType and they've reached the max then we should reenable it
  MealPlan.prototype.enableMealType = function(mealType) {
    var mealList = this.activeWeekContainer.querySelector('.meal[data-meal-type="' + mealType + '"]');
    mealList.querySelectorAll('.product-card--disabled').forEach(function(productCard) {
      productCard.classList.remove('product-card--disabled');
      productCard.querySelector('.product-details--added').style.display = "none";
    });
  }

  // Hide the current week and show the next week.
  // We reset all values in here.
  MealPlan.prototype.switchWeek = function(event, toWeek) {
    var week = toWeek;
    if (event) {
      event.preventDefault();
      week = parseInt(event.target.dataset.week, 10);
      var button = event.target;
    }
    var currWeekBtn = document.querySelector('.btn--week-active');
    var nextWeekBtn =  document.querySelector('.btn--week[data-week="' + week + '"]')
    currWeekBtn.classList.remove('btn--primary');
    currWeekBtn.classList.remove('btn--week-active');
    currWeekBtn.classList.add('btn--secondary');
    nextWeekBtn.classList.add('btn--week-active');
    nextWeekBtn.classList.remove('btn--secondary');
    nextWeekBtn.classList.add('btn--primary');
    document.querySelector('[data-week="' + this.activeWeek + '"]').classList.remove('mealplan__week--active');
    document.querySelector('[data-week="' + week + '"]').classList.add('mealplan__week--active');
    this.activeWeek = week;
    this.activeWeekContainer.classList.remove('mealplan__week--active');
    this.activeWeekContainer = document.querySelector('.mealplan__week[data-week="' + this.activeWeek + '"]');
    this.activeWeekContainer.classList.add('mealplan__week--active');
    this.$mealList.slick('setPosition');
    if (!this.meals[week]) {
      this.meals[week] = {breakfast: [], lunch: [], dinner: []};
    }
    // var countNCost = this.calculateCountAndCost(this.activeWeek);
    this.meal_count = this.calculateCount(this.activeWeek);
    this.renderPage();
    // May initialize slick for the week.
  }

  MealPlan.prototype.disableAllMealPlans = function() {
    this.activeWeekContainer.querySelectorAll('.product-card').forEach(function(productCard) {
      productCard.classList.add('product-card--disabled');
    });
  }

  MealPlan.prototype.enableAllMealPlans = function() {
    this.activeWeekContainer.querySelectorAll('.product-card').forEach(function(productCard) {
      productCard.classList.remove('product-card--disabled');
    });
  }

  MealPlan.prototype.calculateCount = function(week) {
    // Calculate the cost for the week
    var cost = 0;
    var week = this.meals[week];
    var meals = Object.keys(week);
    var count = 0;
    meals.forEach(function(meal) {
      count += week[meal].length;
    });
    return count;
  }

  MealPlan.prototype.processQueue = function(productQueue) {
    var queue = productQueue.slice(0);
    var item = queue.pop();
    var self = this;
    $.ajax({
      url: '/cart/add.js',
      data: item,
      dataType: 'json',
      method: 'POST',
      success: function(res) {
        if (queue.length) {
          self.processQueue(queue);
          return;
        } else {
          ajaxCart.load();
          self.meals[self.activeWeek] = {'breakfast': [], 'lunch': [], 'dinner': [], 'snacks': []};
          // self.switchWeek(null, self.activeWeek+1);
        }
      }
    });
  }

  MealPlan.prototype.addMealPlan = function(event) {
    event.preventDefault();
    var weeks = Object.keys(this.meals);
    var mealPlan = this.meals;
    var self = this;
    weeks.forEach(function(week) {
      var weekPlan = mealPlan[week];
      var meals = Object.keys(weekPlan);
      var products = [];
      var properties = { 'week': week, mealPlan: self.mealPlan, mealPlanTitle: self.mealPlanTitle };
      meals.forEach(function(meal) {
        var tempProducts = weekPlan[meal].map(function(product) {
          return  { id: product.variants[0].id, quantity: 1, properties: properties };
        });
        products = products.concat(tempProducts);
      });
      if (products.length) {
        self.processQueue(products);
      }
    });
  }

  MealPlan.prototype.viewSetMealPlan = function() {
    /*
     * This will do something one day.
     * Only show products that have the tag "SET_MENU"
     * Show the subscription form.
     * This will trigger for prescribed customers and people who choose to view the set menu.
    */
  }

  return MealPlan;
})();
